import {
  selectActiveWidgetIds,
  useDashboardScreenshotStore
} from "./useDashboardScreenshotStore";

/**
 * Returns `true` when the given widget is participating in an active
 * dashboard screenshot session.
 */
export function useIsDashboardScreenshotMode(widgetId: string): boolean {
  return useDashboardScreenshotStore(
    (s) => s.isActive && selectActiveWidgetIds(s).includes(widgetId)
  );
}
